import { useEffect, useState } from "react";
import CallAPI from "../api";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";

export default function useVerifyEmployee(token){
    const [account,setaccount]=useState();
    const [loading,setloading]=useState(false);
    const [password,setpassword]=useState();
    const navigate=useNavigate();
    useEffect(()=>{
     if(token){
        localStorage.setItem("access_token",token);
        CallAPI("employee/selfdetails")
     .then((res)=>setaccount(res.data))
     .catch(err=>console.log(err))
     }
    },[token])

    const handleChange=(e)=>{
        setpassword(e.target.value)
    }
    const submit=async ()=>{
        setloading(true);
   try {
   const res= await CallAPI("employee/setpassword","post",{password});
    Swal.fire("Success",res.message,"success");
    navigate("/");
   } catch (error) {
    console.log(error);
   }
   setloading(false);
    }

    return {account,loading,password,handleChange,submit};
}